import { useEffect } from "react"
import { useContentLanguage } from "routes/schedule/plugins/translation/content-language-context"
import { getMessagePrograms } from "./controller/get-message-programs"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { setProgramCacheError, setProgramCacheLoading, setPrograms } from "./program-cache"

const CORE_NS = ["core"]

/**
 * Headless root component: keeps module-level message program cache in sync with GraphQL.
 */
export function MessageProgramLoader() {
    const { language } = useContentLanguage()
    const lang = language || "en"
    const programs = getMessagePrograms.useResults(
        { language: lang, namespaces: CORE_NS },
        withInitialValue(IS_LOADING)
    )

    useEffect(applyProgramsToCache, [lang, programs])

    return null

    function applyProgramsToCache() {
        if (programs === IS_LOADING) {
            setProgramCacheLoading(lang)
            return
        }
        if (programs == null || typeof programs !== "object") {
            setProgramCacheError(lang)
            return
        }
        setPrograms(programs, lang, "core")
    }
}
